import { render, staticRenderFns } from "./department-selector.vue?vue&type=template&id=481b8817"
import script from "./department-selector.vue?vue&type=script&lang=ts"
export * from "./department-selector.vue?vue&type=script&lang=ts"
import style0 from "./department-selector.vue?vue&type=style&index=0&id=481b8817&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports